import api from '../api';
import { ensureCampaign } from './campaignHelpers';

// Upload a clothing image immediately and return its backend ID
// This prevents ERR_FILE_NOT_FOUND errors when user waits too long before generating
const uploadClothingImage = async (file: File): Promise<number> => {
    const campaignId = await ensureCampaign();

    const formData = new FormData();
    formData.append('image_file', file);
    formData.append('status', 'uploaded');
    formData.append('campaign_id', campaignId.toString());

    const response = await api.post('/images', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000, // 2 min — arquivos grandes podem demorar no upload + S3 + thumbnail
    });
    return (response.data as any).data.id;
};

export const uploadService = { uploadClothingImage };
